// extracted by mini-css-extract-plugin
export default {"mCard":"jD-z","image":"kD-z","imageNoBackground":"lD-z","imageHasCategory":"mD-z","fullWidth":"nD-z"};